export default __webpack_public_path__ + "static/media/key1.c55386e2.jpg";